export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 100 CARDS',
    cards: [
      {n:'1', name:'Luke in Peril!'},
      {n:'2', name:'Wise Yoda'},
      {n:'3', name:'Hoth from the Air'},
      {n:'4', name:'Incoming Transmission'},
      {n:'5', name:'The Princess & The Scoundrel'},
      {n:'6', name:'Becoming Sith'},
      {n:'7', name:'Han Solo Draws!'},
      {n:'8', name:'The Bespin Administrator'},
      {n:'9', name:'Wild Wampa'},
      {n:'10', name:'The Emperor Up Close'},
      {n:'11', name:'Holochess Contest'},
      {n:'12', name:"Beggar's Canyon Run"},
      {n:'13', name:'Gamorrean Charge!'},
      {n:'14', name:'Skirmish Above the Sarlacc!'},
      {n:'15', name:"Yoda's Hut"},
      {n:'16', name:'Imperial Agents of Evil'},
      {n:'17', name:'Showdown on Dagobah'},
      {n:'18', name:"AT-STs on the Prowl"},
      {n:'19', name:'Ravenous Rancor'},
      {n:'20', name:'The Torture Droid'},
      {n:'21', name:'Embattled Han & Chewie'},
      {n:'22', name:'Carbonite Chamber Duel'},
      {n:'23', name:'An Upset Wookiee'},
      {n:'24', name:'Stormtrooper Overrun!'},
      {n:'25', name:'Wading Through the Swamp'},
      {n:'26', name:'On the Hunt'},
      {n:'27', name:'A Plan in Action'},
      {n:'28', name:'From the Eyes of the Admiral'},
      {n:'29', name:'Salacious B. Crumb'},
      {n:'30', name:'Weight of Destiny'},
      {n:'31', name:"Kenobi's Visage"},
      {n:'32', name:'Enlist!'},
      {n:'33', name:'Masters of the Force'},
      {n:'34', name:'Future of the Jedi'},
      {n:'35', name:'Vader Redeemed'},
      {n:'36', name:'Luke Stands Ready'},
      {n:'37', name:'From the Depths'},
      {n:'38', name:'Marching AT-STs'},
      {n:'39', name:"Galaxy's Most Dangerous"},
      {n:'40', name:'The Star Wars Saga'},
      {n:'41', name:'Old Master Yoda'},
      {n:'42', name:'Diabolic Duo'},
      {n:'43', name:'Lando Calrissian'},
      {n:'44', name:'Wing Man'},
      {n:'45', name:'Take The Bait'},
      {n:'46', name:'Sneaking Around Danger'},
      {n:'47', name:'Remnants of Kenobi'},
      {n:'48', name:'A Dyad in the Force'},
      {n:'49', name:'Ambush from Above'},
      {n:'50', name:'A Queen in Portrait'},
      {n:'51', name:'The Captain Captured!'},
      {n:'52', name:"A Young Jedi's Stance"},
      {n:'53', name:'Tusken Under Twin Suns'},
      {n:'54', name:'Flight of the Millennium Falcon'},
      {n:'55', name:'Jango Draws His Pistols'},
      {n:'56', name:"Maul's Rage"},
      {n:'57', name:"The Empire's Forces"},
      {n:'58', name:'A Squad of Bounty Hunters'},
      {n:'59', name:'Attack on Takodana'},
      {n:'60', name:'Face the Dark Side'},
      {n:'61', name:'Projection'},
      {n:'62', name:'Sunset'},
      {n:'63', name:'The Sacred Tree'},
      {n:'64', name:'Odd Couple'},
      {n:'65', name:'Dark Order'},
      {n:'66', name:'What a Piece of Junk'},
      {n:'67', name:'Bucket of Bolts'},
      {n:'68', name:'Just Like Back Home'},
      {n:'69', name:'Patrolling the Endor Moon'},
      {n:'70', name:'The Masters of Evil'},
      {n:'71', name:'Master of Evil'},
      {n:'72', name:'Bounty Acquired'},
      {n:'73', name:"He's All Yours, Bounty Hunter"},
      {n:'74', name:'The Reunion'},
      {n:'75', name:'Battle of Yavin'},
      {n:'76', name:'Predator & Prey'},
      {n:'77', name:'Do. Or Do Not.'},
      {n:'78', name:'The Pursuit'},
      {n:'79', name:'Dune Sea Palace'},
      {n:'80', name:'Shiny Return'},
      {n:'81', name:'The Dark Side'},
      {n:'82', name:'Princess Leia Organa'},
      {n:'83', name:'Planetesimals'},
      {n:'84', name:'Lobot'},
      {n:'85', name:'Sandtroopers'},
      {n:'86', name:'Battle of Endor'},
      {n:'87', name:'Lifting the X-Wing'},
      {n:'88', name:'Bespin Bounty Hunter'},
      {n:'89', name:'X-Wings'},
      {n:'90', name:'Daybreak on Hoth'},
      {n:'91', name:'Tatooine Sunset'},
      {n:'92', name:'Dark Side'},
      {n:'93', name:'Dawn of the Rebellion'},
      {n:'94', name:'Pinned Down'},
      {n:'95', name:'Storming Rebels'},
      {n:'96', name:"Vader's Shuttle"},
      {n:'97', name:'Vengeful Pursuit'},
      {n:'98', name:'74-Z Speeder Bike'},
      {n:'99', name:'Night Must Fall'},
      {n:'100', name:'Forced in Darkness'},
    ]
  },
  {
    id: 'galactic-visions', type: 'insert', title: 'GALACTIC VISIONS — 20 CARDS',
    cards: [
      {n:'GV-1', name:'Galactic Visions 1'},{n:'GV-2', name:'Galactic Visions 2'},
      {n:'GV-3', name:'Galactic Visions 3'},{n:'GV-4', name:'Galactic Visions 4'},
      {n:'GV-5', name:'Galactic Visions 5'},{n:'GV-6', name:'Galactic Visions 6'},
      {n:'GV-7', name:'Galactic Visions 7'},{n:'GV-8', name:'Galactic Visions 8'},
      {n:'GV-9', name:'Galactic Visions 9'},{n:'GV-10', name:'Galactic Visions 10'},
      {n:'GV-11', name:'Galactic Visions 11'},{n:'GV-12', name:'Galactic Visions 12'},
      {n:'GV-13', name:'Galactic Visions 13'},{n:'GV-14', name:'Galactic Visions 14'},
      {n:'GV-15', name:'Galactic Visions 15'},{n:'GV-16', name:'Galactic Visions 16'},
      {n:'GV-17', name:'Galactic Visions 17'},{n:'GV-18', name:'Galactic Visions 18'},
      {n:'GV-19', name:'Galactic Visions 19'},{n:'GV-20', name:'Galactic Visions 20'},
    ]
  },
  {
    id: 'bounty-hunters', type: 'insert', title: "DARTH VADER & THE BOUNTY HUNTERS — 10 CARDS",
    cards: [
      {n:'DVBH-1', name:'Boba Fett', artist:'The Empire Strikes Back'},
      {n:'DVBH-2', name:'Zuckuss', artist:'The Empire Strikes Back'},
      {n:'DVBH-3', name:'Stormtrooper', artist:'A New Hope'},
      {n:'DVBH-4', name:'Dengar', artist:'The Empire Strikes Back'},
      {n:'DVBH-5', name:'4-LOM', artist:'The Empire Strikes Back'},
      {n:'DVBH-6', name:'Bossk', artist:'The Empire Strikes Back'},
      {n:'DVBH-7', name:'Darth Vader Ignites His Lightsaber', artist:'The Empire Strikes Back'},
      {n:'DVBH-8', name:'Darth Vader', artist:'A New Hope'},
      {n:'DVBH-9', name:'IG-88', artist:'The Empire Strikes Back'},
      {n:'DVBH-10', name:'Darth Vader & His Stormtroopers', artist:'A New Hope'},
    ]
  },
  {
    id: 'rotj-40th', type: 'insert', title: 'RETURN OF THE JEDI 40TH ANNIVERSARY POSTER ART — 5 CARDS',
    cards: [
      {n:'ROTJ-1', name:'ROTJ 40th Anniversary Poster 1'},
      {n:'ROTJ-2', name:'ROTJ 40th Anniversary Poster 2'},
      {n:'ROTJ-3', name:'ROTJ 40th Anniversary Poster 3'},
      {n:'ROTJ-4', name:'ROTJ 40th Anniversary Poster 4'},
      {n:'ROTJ-5', name:'ROTJ 40th Anniversary Poster 5'},
    ]
  },
  {
    id: 'women-of-sw', type: 'insert', title: 'WOMEN OF STAR WARS — 15 CARDS',
    cards: [
      {n:'WSW-1', name:'Hera Syndulla', artist:'Star Wars Rebels'},
      {n:'WSW-2', name:'Padmé Amidala', artist:'The Phantom Menace'},
      {n:'WSW-3', name:'Rey & Kylo Ren', artist:'The Last Jedi'},
      {n:'WSW-4', name:'Asajj Ventress', artist:'The Clone Wars'},
      {n:'WSW-5', name:'Princess Leia & Wicket', artist:'Return of the Jedi'},
      {n:'WSW-6', name:'Sabine Wren', artist:'Star Wars Rebels'},
      {n:"WSW-7", name:"Ahsoka Tano's New Path", artist:'Star Wars Rebels'},
      {n:'WSW-8', name:'Queen Amidala', artist:'The Phantom Menace'},
      {n:"WSW-9", name:"The Queen's Handmaidens", artist:'The Phantom Menace'},
      {n:"WSW-10", name:"Qi'ra", artist:'Solo: A Star Wars Story'},
      {n:'WSW-11', name:'Rey Lifting Rocks', artist:'The Last Jedi'},
      {n:'WSW-12', name:'Maz Kanata', artist:'The Force Awakens'},
      {n:'WSW-13', name:'Mon Mothma', artist:'Rogue One'},
      {n:'WSW-14', name:'Aayla Secura', artist:'Attack of the Clones'},
      {n:'WSW-15', name:'Princess Leia', artist:'A New Hope'},
    ]
  },
  {
    id: 'kyber', parallels: [], type: 'insert', title: 'KYBER CRYSTAL DIE-CUTS — 4 CARDS',
    cards: [
      {n:'KCD-12', name:'Kanan Jarrus'},
      {n:'KCD-13', name:'Count Dooku'},
      {n:'KCD-14', name:'Asajj Ventress'},
      {n:'KCD-15', name:'Yoda'},
    ]
  },
  {
    id: 'auto-dual', parallels: [{id:'numbered',name:'',print_run:25,color:'#c8d8f0'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'DUAL AUTOGRAPHS — 4 CARDS',
    cards: [
      {n:'DA-FH', name:'Mark Hamill / Harrison Ford', artist:'Luke / Han'},
      {n:'DA-MV', name:'Ewan McGregor / Indira Varma', artist:'Obi-Wan / Tala'},
      {n:'DA-NF', name:'Harrison Ford / Lupita Nyong\'o', artist:'Han / Maz'},
      {n:'DA-PG', name:'Sarah Michelle Gellar / Freddie Prinze Jr.', artist:'7th Sister / Kanan'},
    ]
  },
  {
    id: 'auto-triple', parallels: [{id:'numbered',name:'',print_run:5,color:'#c8d8f0'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'TRIPLE AUTOGRAPHS — 1 CARD',
    cards: [
      {n:'TA-DSM', name:'Ian McDiarmid / Andy Serkis / Adam Driver', artist:'Palpatine / Snoke / Kylo'},
    ]
  },
  {
    id: 'sketch', parallels: [], type: 'sketch', title: 'SKETCH CARDS',
    cards: [{n:'SK-1', name:'Sketch Card', artist:'Various Artists'}]
  },
];
export const PARALLELS = [
  { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
  { id: 'aqua', name: 'Aqua Refractor', print_run: 199, color: '#00e5ff' },
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const AUTO_PARALLELS = [
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const INSERT_PARALLELS = [
  { id: 'aqua', name: 'Aqua Refractor', print_run: 199, color: '#00e5ff' },
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'green', name: 'Green Refractor', print_run: 99, color: '#00e676' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'purple', name: 'Purple Refractor', print_run: 50, color: '#b060ff' },
  { id: 'wave35', name: 'Wave Refractor', print_run: 35, color: '#00b0ff' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
